import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { AccProspectAlignedCommitment } from '@interfaces';
import { AppService } from '../../../../services';
import { AccApplicationDialogDataService } from '../acc-application-dialog-data.service';
import { getSetup } from './grid/get-setup';

export interface AlignedCommitment extends AccProspectAlignedCommitment {
	startTrimester: string,
	endTrimester: string,
	updatedUTC: number,
}

@Component({
	selector: 'application-dialog-aligned-commitments-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './aligned-commitments.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class ApplicationDialogAlignedCommitmentsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	public accApplDialogDataService = inject(AccApplicationDialogDataService);

	public setup = getSetup(this.util, this.accApplDialogDataService);

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.accApplDialogDataService.isReadonly() ? 45 : 0));

	public alignedCommitments = computed<AlignedCommitment[]>(() => {
		const data = this.accApplDialogDataService.dialogData();
		if (!data) return [];

		return data.alignedCommitments.map(c => {
			return {
				...c,
				startTrimester: this.app.getTrimesterNameById(c.startTrimesterId),
				endTrimester: this.app.getTrimesterNameById(c.endTrimesterId),
				updatedUTC: Date.now() / 1000,
			}
		})

	});
}